module.exports = __webpack_public_path__ + "img/1511613685.9cc08b54.jpg";